import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import type { FCWithChildren } from "../@types";
import routes from "../app/routes";

export const ScrollRestoration: FCWithChildren = ({ children }) => {
  const { pathname } = useLocation();
  // Skip for any routes that rerender all content on changes to the `page`
  // query param (Enrollment is the only example as of the time this was written)
  const queryParamPageRoutes = [routes.enroll] as string[];
  const queryParamRoutedPage = queryParamPageRoutes.includes(pathname);
  const [previousPathname, setPreviousPathname] = useState(pathname);

  // For "normal" routes, watch changes to pathname and scroll to top
  useEffect(() => {
    if (queryParamRoutedPage || previousPathname === pathname) {
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setPreviousPathname(pathname);
  }, [pathname, previousPathname, queryParamRoutedPage]);

  return <>{children}</>;
};
